/**
 * 攤平資料用
 * example:
 *    parameters = {
 *       alias1: {
 *         paramA: 123,
 *         paramB: 'test'
 *       },
 *       alias2: {
 *         paramA: 456,
 *         paramB: 'test87'
 *       }
 *    }
 *
 *  經過此function可變為
 *    newParams = {
 *      alias1_paramA: 123,
 *      alias1_paramB: 'test',
 *      alias2_paramA: 456,
 *      alias2_paramB: 'test87'
 *    }
 *
 */
export function buildVariablesWithAliases(parameters) {
  let newParams = {}
  let aliases = Object.keys(parameters)
  aliases.forEach(alias => {
    let aliasParams = parameters[alias]
    Object.keys(aliasParams).forEach(pName => {
      newParams[`${pName}_${alias}`] = aliasParams[pName]
    })
  })
  return newParams
}
